import {ConfigObjectType} from '@wallaby-ui/core';
import {useOrganizationsByOrgSecurity} from '@wallaby-ui/document';
import {useMemo} from 'react';

export const useHospitalOptions = (config: ConfigObjectType) => {
  const {data: organizations} = useOrganizationsByOrgSecurity(config);
  const hospitalOptions = useMemo(
    () =>
      (organizations ?? [])
        .filter((v) => v.levelType === 'HOSPITAL')
        .map((v) => ({
          id: v.id,
          label: v.organizationLongName,
        })),
    [organizations]
  );
  const firstHospitalOption = hospitalOptions.length > 0 ? hospitalOptions[0] : null;
  return {
    hospitalOptions,
    firstHospitalOption,
  };
};
